const mapLegacyTypeToKind = (type) => {
    switch (type) {
        case 'image':
            return 'image';
        case 'video':
            return 'video';
        case 'audio':
            return 'audio';
        default:
            return 'file';
    }
};

const kindFromMime = (mime = '') => {
    if (!mime) return null;
    if (mime.startsWith('image/')) return 'image';
    if (mime.startsWith('video/')) return 'video';
    if (mime.startsWith('audio/')) return 'audio';
    return 'file';
};

const generateId = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return `att-${Date.now()}-${Math.random()}`;
};

export const normalizeAttachmentKey = (url = '') => {
    if (!url) return '';
    try {
        const parsed = new URL(url);
        return parsed.pathname || '';
    } catch (error) {
        return url;
    }
};

export const niceNameFromUrl = (url = '') => {
    if (!url) return '';
    try {
        const withoutQuery = url.split('?')[0];
        const parts = withoutQuery.split('/');
        const last = parts[parts.length - 1] || '';
        return decodeURIComponent(last);
    } catch {
        return url;
    }
};

export const normalizeAttachment = (item = {}, questionId = 'unknown', index = 0) => {
    const derivedKind = item.kind || kindFromMime(item.mime) || mapLegacyTypeToKind(item.type);
    const derivedId = item.id || `legacy-${questionId}-${index}`;
    const title = item.title || item.name || item.displayName || item.originalName || niceNameFromUrl(item.url) || '';
    const urlKey = normalizeAttachmentKey(item.url || '');

    return {
        id: derivedId,
        kind: derivedKind || 'file',
        type: derivedKind || item.type || 'file',
        url: item.url || '',
        urlKey,
        title,
    };
};

export const normalizeAttachments = (attachments = [], questionId) =>
    (attachments || []).map((att, index) => normalizeAttachment(att, questionId, index));

export const deriveKindFromMime = kindFromMime;
export const buildAttachmentPayload = (fileMeta) => {
    const { url, originalName, mime } = fileMeta || {};
    const kind = deriveKindFromMime(mime) || 'file';
    const id = generateId();
    return {
        id,
        type: kind,
        kind,
        url,
        title: originalName || url,
    };
};

export default normalizeAttachments;
